export default "__VITE_ASSET__Ck_Vn99q__"